import { useQueryAuditLog } from '../../models/useQueryAuditLog'

export const useAuditLogListPresenter = ({
  contentTypeId,
  objectId,
}: {
  contentTypeId: number
  // Omitted → module-wide log for the content type (BHV-030)
  objectId?: string
}) => {
  const { auditLog, isLoading } = useQueryAuditLog({
    contentTypeId,
    objectId,
  })

  const showAuditLog = auditLog && auditLog.length > 0

  return {
    data: { auditLog },
    state: { showLoader: isLoading, showAuditLog },
  }
}
